import { ReactNode, useEffect, useState } from "react";
import Brand from "./Brand";
import ExhibitAudioPlayer from "./ExhibitAudioPlayer";
import { RoomId, useTranslation } from "./Localization";
import { getPage, PageContentItem } from "../services/pagesApi";

type RoomPageProps = {
  roomId: RoomId;
  slug: string;
  navigation: ReactNode;
  className?: string;
  heroClassName?: string;
  headingClassName?: string;
  bottomClassName?: string;
};

export default function RoomPage({
  roomId,
  slug,
  navigation,
  className = "",
  heroClassName = "",
  headingClassName = "",
  bottomClassName = "",
}: RoomPageProps) {
  const { language, room } = useTranslation();
  const translatedRoom = room(roomId);
  const [items, setItems] = useState<PageContentItem[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setItems(null);
    getPage(slug, language, controller.signal)
      .then((page) => setItems(page.items))
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === "AbortError") return;
        setItems([]);
      });
    return () => controller.abort();
  }, [language, slug]);

  const image = items?.find((item) => item.kind === "image" && item.url);
  const audioTracks = items
    ?.filter((item) => item.kind === "audio" && item.url)
    .map((item) => ({ src: item.url as string, title: item.label || translatedRoom?.name || "" }));

  return <main className={`screen exhibit ${className}`.trim()}>
    <div
      className={`exhibit-hero ${heroClassName}`.trim()}
      style={{ backgroundColor: "#000", backgroundImage: image?.url ? `url(${image.url})` : "none" }}
    />
    <header className={`exhibit-heading ${headingClassName}`.trim()}>
      <Brand compact />
      <div>
        <strong>{translatedRoom && (translatedRoom.number !== null ? `${translatedRoom.number}. ${translatedRoom.name}` : translatedRoom.name)}</strong>
        <small>{translatedRoom?.location}</small>
      </div>
    </header>
    <section className={`exhibit-bottom ${bottomClassName}`.trim()}>
      {audioTracks?.length ? <ExhibitAudioPlayer roomId={roomId} title={audioTracks[0].title} tracks={audioTracks} /> : null}
      {navigation}
    </section>
  </main>;
}
